export default function Testimonial() {
  return (
    <section className="py-24 bg-[#f8f6f0] relative overflow-hidden">
      {/* 装饰线条 */}
      <div className="absolute top-20 left-0 w-64 h-64 opacity-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <path d="M 0 100 Q 50 50 100 100 T 200 100" stroke="#333" fill="none" strokeWidth="2"/>
          <path d="M 0 120 Q 50 70 100 120 T 200 120" stroke="#333" fill="none" strokeWidth="2"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="relative bg-[#0a0a0a] rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
            {/* 左侧照片 */}
            <div className="relative lg:col-span-1">
              <div className="absolute inset-0 lg:relative lg:inset-auto w-full h-64 lg:h-full">
                <img 
                  src="https://public.readdy.ai/ai/img_res/9d3f7abb29e5f56060cd4f7a7a867193.jpg"
                  alt="客户评价"
                  className="w-full h-full object-cover rounded-t-3xl lg:rounded-l-3xl lg:rounded-tr-none"
                />
              </div>
            </div>

            {/* 右侧内容 */}
            <div className="lg:col-span-2 p-12 lg:p-16 flex flex-col justify-center">
              {/* 引号 */}
              <div className="text-7xl text-[#f5f0e8] mb-6 font-serif">"</div>

              {/* 评价内容 */}
              <p className="text-2xl md:text-3xl text-white leading-relaxed mb-8 font-light">
                部署智慧港航无人机平台后,我们的堆场盘点效率提升了5倍,安全事故率下降80%,真正实现了港口运营的智能化升级
              </p>

              {/* 署名 */}
              <div className="space-y-2">
                <div className="text-xl text-white font-medium">
                  张明 | 某大型港口集团
                </div>
                <div className="text-base text-gray-400">
                  运营总监
                </div>
              </div>

              {/* 按钮 */}
              <div className="mt-8">
                <button className="px-8 py-3 bg-[#ffb3ba] text-gray-900 font-medium rounded-full hover:bg-[#ff9ba3] transition-colors cursor-pointer whitespace-nowrap">
                  查看更多案例
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}